import { isAnyOf } from "@reduxjs/toolkit";
import { setApplicationRoutingData, setNhDealApplicationId } from "features/authSlice";
import { clearLoanOfficerDetail } from "services/common/loanOfficerSlice";
import { listenerMiddleware } from "./logoutListners";

interface StateWithAuth {
  auth?: { nhDealApplicationId?: string };
}

const getNhDealApplicationId = (state: unknown): string => (state as StateWithAuth)?.auth?.nhDealApplicationId ?? "";

// Refetch the loan officer detail when the nhDealApplicationId changes (my-loans page).
listenerMiddleware.startListening({
  matcher: isAnyOf(setNhDealApplicationId, setApplicationRoutingData),
  effect: (_action, listenerApi) => {
    const previousnhDealAppId = getNhDealApplicationId(listenerApi.getOriginalState());
    const currentnhDealAppId = getNhDealApplicationId(listenerApi.getState());

    if (previousnhDealAppId && currentnhDealAppId && previousnhDealAppId !== currentnhDealAppId) {
      listenerApi.dispatch(clearLoanOfficerDetail());
    }
  },
});
